/**
 * OTC subtype filter for api/admin/transactions/data?type=otc.
 *
 * The API requires `otcSubtypes` for `type=otc` and accepts exactly one value —
 * a comma-separated list is rejected with "OTC subtype must be one of:
 * otc-deposit, otc-payout" — so there is no "all" option; callers pick a side.
 *
 * The summaries endpoint does NOT accept this param ("otcSubtypes is not
 * allowed") and is always unfiltered, same as `billSubtypes`.
 */
export type OtcSubtypeFilterValue = "otc-deposit" | "otc-payout";

export const DEFAULT_OTC_SUBTYPE: OtcSubtypeFilterValue = "otc-deposit";

export const OTC_SUBTYPE_FILTERS: {
  value: OtcSubtypeFilterValue;
  label: string;
}[] = [
  { value: "otc-deposit", label: "Deposits" },
  { value: "otc-payout", label: "Payouts" },
];

/** Resolves to the `otcSubtypes` query param (never empty — the API requires it). */
export function otcSubtypesParam(
  filter: OtcSubtypeFilterValue | undefined
): OtcSubtypeFilterValue {
  return filter ?? DEFAULT_OTC_SUBTYPE;
}
